import React from 'react'

import TitleHolder from '../TitleHolder/TitleHolder'
import WebMenu from './WebMenu'

const WebMenuHolder = ({ title }) => (
  <div className="web-menu-holder">
    <TitleHolder title={title} showMenu />
    <WebMenu />
  </div>  
)

export default WebMenuHolder


// WEBPACK FOOTER //
// ./src/components/shared/WebMenu/WebMenuHolder.js